import { render, staticRenderFns } from "./WebProfileAcceptPage.vue?vue&type=template&id=289d0561&"
import script from "./WebProfileAcceptPage.vue?vue&type=script&lang=js&"
export * from "./WebProfileAcceptPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports